import apiService from '@/services/apiService';

const actions = {
  getHowTos({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('paxel-recycle/how-to/find-with-paging', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getHowTo({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.get(`paxel-recycle/how-to/${payload}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  orderHowTo({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`paxel-recycle/how-to/${payload.id}/change-order`, payload.orderData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  postHowTo({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('paxel-recycle/how-to', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putHowTo({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`paxel-recycle/how-to/${payload.id}`, payload.formData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  delHowTo({ commit }, payload) {
    return new Promise((resolve, reject) => {
    apiService.delete(`paxel-recycle/how-to/${payload}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
    });
  },

};

export default actions;
